module.exports = new __parcel__URL__("background.80634931.mp4").toString();